import React from 'react';

const FormField = ({ 
  label, 
  required = false, 
  error, 
  helpText, 
  children, 
  className = '',
  size = 'md',
  ...props 
}) => {
  const labelClasses = size === 'sm' ? 'block text-xs font-medium text-gray-700 mb-0.5' : 'block text-sm font-medium text-gray-700 mb-1';
  return (
    <div className={className} {...props}>
      {label && (
        <label className={labelClasses}>
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      {children}
      {helpText && (
        <p className="mt-1 text-xs text-gray-500">{helpText}</p>
      )}
      {error && (
        <p className="mt-1 text-xs text-red-600">{error}</p>
      )}
    </div>
  );
};

export default FormField;
